import React, { useState, useEffect } from 'react';
import { useLanguage } from './Header';
import { useTranslation } from '../utils/translations';

const Hero = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);
  const [currentWeather, setCurrentWeather] = useState({
    main: { temp: 28 },
    weather: [{ main: 'Clear' }]
  });
  
  const API_KEY = 'a027b50ee06deba2c952e19c28f6d313';
  
  useEffect(() => {
    fetchCurrentWeather();
  }, []);
  
  const fetchCurrentWeather = async () => {
    try {
      const lat = 12.9716;
      const lon = 77.5946;
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Weather data:', data);
      setCurrentWeather(data);
    } catch (error) {
      console.error('Error fetching weather:', error);
      // Keep dummy data on error
    }
  };
  
  return (
    <section id="dashboard" className="bg-gradient-to-br from-green-50 to-blue-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('farmDashboard')}</h1>
          <p className="text-gray-600">{t('todaysInsights')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{t('todaysWeather')}</p>
                <p className="text-2xl font-bold text-gray-900">
                  {currentWeather && currentWeather.main ? Math.round(currentWeather.main.temp) : '--'}°C
                </p>
                <p className="text-sm text-green-600">
                  {currentWeather && currentWeather.weather && currentWeather.weather[0] ? 
                    (currentWeather.weather[0].main === 'Clear' ? t('sunny') :
                     currentWeather.weather[0].main === 'Clouds' ? t('cloudy') :
                     currentWeather.weather[0].main === 'Rain' ? t('rainy') : 
                     currentWeather.weather[0].main) : t('loading')}
                </p>
              </div>
              <div className="text-3xl">
                {currentWeather && currentWeather.weather && currentWeather.weather[0] ? 
                  (currentWeather.weather[0].main === 'Clear' ? '☀️' : 
                   currentWeather.weather[0].main === 'Clouds' ? '☁️' : 
                   currentWeather.weather[0].main === 'Rain' ? '🌧️' : 
                   currentWeather.weather[0].main === 'Snow' ? '❄️' : '🌤️') 
                  : '☀️'
                }
              </div>
            </div>
          </div>
          
          <div className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{t('soilMoisture')}</p>
                <p className="text-2xl font-bold text-gray-900">65%</p>
                <p className="text-sm text-blue-600">{t('good')}</p>
              </div>
              <div className="text-3xl">💧</div>
            </div>
          </div>
          
          <div className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{t('cropHealth')}</p>
                <p className="text-2xl font-bold text-gray-900">92%</p>
                <p className="text-sm text-green-600">{t('healthy')}</p>
              </div>
              <div className="text-3xl">🌱</div>
            </div>
          </div>
          
          <div className="card">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{t('nextHarvest')}</p>
                <p className="text-2xl font-bold text-gray-900">45</p>
                <p className="text-sm text-orange-600">{t('days')}</p>
              </div>
              <div className="text-3xl">🌾</div>
            </div>
          </div>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-6">
          <div className="card">
            <h3 className="text-lg font-semibold mb-4">{t('quickActions')}</h3>
            <div className="space-y-3">
              <button className="w-full text-left p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                {t('checkYieldPrediction')}
              </button>
              <button className="w-full text-left p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                {t('scanForDiseases')}
              </button>
              <button className="w-full text-left p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                {t('weatherForecast')}
              </button>
            </div>
          </div>
          
          <div className="card lg:col-span-2">
            <h3 className="text-lg font-semibold mb-4">{t('todaysRecommendations')}</h3>
            <div className="space-y-3">
              <div className="p-3 bg-green-50 border-l-4 border-green-400 rounded">
                <p className="font-medium text-green-800">{t('waterTomatoes')}</p>
                <p className="text-sm text-green-600">{t('soilMoistureOptimal')}</p>
              </div>
              <div className="p-3 bg-blue-50 border-l-4 border-blue-400 rounded">
                <p className="font-medium text-blue-800">{t('applyFertilizer')}</p>
                <p className="text-sm text-blue-600">{t('growthStageOptimal')}</p>
              </div>
              <div className="p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                <p className="font-medium text-yellow-800">{t('monitorPests')}</p>
                <p className="text-sm text-yellow-600">{t('weatherFavorsPests')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;